import { GdkCheckpoint } from "@gdk/checkpoint";
import React, { useEffect } from "react";
import GeaoLayout from "../shared/Layout/GeaoLayout";
import { useNavigate } from "react-router-dom";
import { GeaoPaths } from "../../constants/GeaoPaths";
import useInterviewsInitializedCheck from "../../hooks/useInterviewsInitializedCheck";
import useGtmTracking from "../../../../hooks/useGtmTracking";

export default function ProducerWelcomeChecklist() {
    useGtmTracking("AgentOverview", "preonboarding_complete");
    useGtmTracking("AgentOverview", "onboarding_agent_start");

    const navigate = useNavigate();
    useInterviewsInitializedCheck();

    useEffect(() => {
        new GdkCheckpoint({
            content: `#overview-checkpoint`,
            data: [
                {
                    title: "Create Your Profile",
                    status: "completed"
                },
                {
                    title: "Complete Application",
                    status: "in process"
                },
                {
                    title: "Background Check"
                },
                {
                    title: "Start Selling with GEICO"
                }
            ],
            animated: false
        });
    }, []);

    return <GeaoLayout>
        <h2 className="mx-auto mt-5 mb-1">Welcome to GEICO For Your Agency.</h2>
        <div className="mx-auto mb-5">Thanks for considering becoming an agent with GEICO!</div>
        <div className="container margin-top">
            <div className="row">
                <div className="col-md-6">
                    <div className="checkpoint p-3 background m-2 overview-block" id="overview-checkpoint">
                        <p className="checkpoint checkpoint-heading">What's Next?</p>
                        <ul className="checkpoint-content"></ul>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="m-2">
                        <p className="header-text">Have these details ready:</p>
                        <ul className="list list--unordered">
                            <li>
                                Personal Information
                            </li>
                            <li>
                                Individual Background Information
                            </li>
                            <li>
                                Branch Office Information (If Applicable)
                            </li>
                        </ul>
                        <p>
                            You'll confirm and submit your application with an electronic signature.
                        </p>
                        <p>
                            This task will take approximately 15 minutes.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="mx-auto mt-5" style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <button
                type="submit"
                className="btn-center btn--primary btn--full-mobile"
                style={{ width: '350px', marginBottom: 5 }}
                onClick={() => navigate(GeaoPaths.ProducerPersonalInformation)}
            >
                <span>
                    Begin New Application
                </span>
            </button>

            <button
                type="submit"
                className="btn-center btn--secondary btn--full-mobile"
                style={{ width: '350px' }}
                onClick={() => navigate(GeaoPaths.ApplicationStatus)}
            >
                <span>
                    View Application Status
                </span>
            </button>
        </div>
    </GeaoLayout>
}
